import { FavoriteTypeEnum } from '../../types/account/favoriteTypeTypes.ts';
import { NotificationTypeTypes } from '../../types/account/notificationTypeTypes.ts';
import { IFavorite } from '../../interfaces/account/favorite/IFavorite.ts';
import { ReminderStatusTypeTypes } from '../../types/account/reminderStatusTypeTypes.ts';
import { IReminder } from '../../interfaces/account/reminder/IReminder.ts';
import { INotification } from '../../interfaces/account/notification/INotification.ts';

export interface IGetMeResponse {
    user: IUserDto;
    favorites: IFavoriteDto[];
    finances: IFinanceDto;
    notifications: INotificationDto[];
    recordings: IRecordingDto[];
    reminders: IReminderDto[];
}

export interface IFavoriteDto {
    id: string;
    name: string;
    search_query: string;
    position: number;
    type: FavoriteTypeEnum;
}

interface IFinanceDto {
    balance: number;
}

export interface INotificationDto {
    id: string;
    title: string;
    type: NotificationTypeTypes;
    target: string;
    is_read: boolean;
    created_at: string;
}

export function mapINotificationDtoToModel(dto: INotificationDto): INotification {
    return {
        id: dto.id,
        title: dto.title,
        target: dto.target,
        type: dto.type,
        createdAt: dto.created_at,
        isRead: dto.is_read,
    };
}

export interface IRecordingDto {
    id: number;
    program_real_id: string;
}

export interface IUserDto {
    id: string;
    customer_id: number;
    roles: string[];
}

export interface IReminderDto {
    id: string,
    target_type: NotificationTypeTypes,
    target_id: string,
    status: ReminderStatusTypeTypes
}

export function mapIReminderDtoToModel(dto: IReminderDto): IReminder {
    return {
        id: dto.id,
        targetType: dto.target_type,
        targetId: dto.target_id,
        status: dto.status,
    };
}

export function mapIFavoriteDtoToModel(dto: IFavoriteDto): IFavorite {
    return {
        id: dto.id,
        name: dto.name,
        searchQuery: dto.search_query,
        position: dto.position,
        type: dto.type,
    };
}